import React from "react"
import { FeedListBlock, FeedNotExistTxtBlock, FeedNotExistTxt } from "./style"
import FeedItem from "components/presenters/feed/detail/FeedItem"

const FeedList = ({
  feedList,
  userInfo,
  addLikeRequest,
  deleteLikeRequest,
  handleBottomModalState,
  commentVisible,
  commentList,
  currentFeedNo,
  handleFeedScroll,
  handleCommentBottomModal,
  loadNextComments,
  handleDoubleClick,
  showCommentCount,
  insertedCommentList,
  lottieOptions,
  isLikeAnimation,
  onClickComment,
  feedDescLimit,
  handleClickMore,
  showMoreFeedNoList,
  reportedUserNo,
}) => {
  return (
    <FeedListBlock
      onScroll={(e) => {
        if (handleFeedScroll) handleFeedScroll(e)
      }}
    >
      {feedList.length === 0 ? (
        <FeedNotExistTxtBlock>
          <FeedNotExistTxt>아직 등록된 인증샷이 없어요</FeedNotExistTxt>
        </FeedNotExistTxtBlock>
      ) : (
        feedList.map((feedItem, index) => {
          if (reportedUserNo && reportedUserNo.includes(feedItem.user_no)) {
            return null
          }
          return (
            <FeedItem
              key={`feed-detail-list-no-${feedItem["no"]}`}
              feedItem={feedItem}
              userInfo={userInfo}
              addLikeRequest={addLikeRequest}
              deleteLikeRequest={deleteLikeRequest}
              handleBottomModalState={handleBottomModalState}
              commentVisible={commentVisible}
              commentList={commentList}
              currentFeedNo={currentFeedNo}
              handleCommentBottomModal={handleCommentBottomModal}
              loadNextComments={loadNextComments}
              handleDoubleClick={handleDoubleClick}
              showCommentCount={showCommentCount}
              insertedCommentList={insertedCommentList}
              isLikeAnimation={isLikeAnimation}
              lottieOptions={lottieOptions}
              onClickComment={onClickComment}
              feedDescLimit={feedDescLimit}
              handleClickMore={handleClickMore}
              index={index}
              showMoreFeedNoList={showMoreFeedNoList}
            />
          )
        })
      )}
    </FeedListBlock>
  )
}

export default FeedList
